module.exports = __webpack_public_path__ + "img/link_favicon-32x32.e17c5fa1.png";